var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { grayscale } from "polished";
import { getColor, getReadableColor, responsive } from "../../helpers";
var buttonBase = {
  alignItems: "center",
  backgroundColor: "transparent",
  borderColor: "transparent",
  borderRadius: "small",
  borderStyle: "solid",
  borderWidth: "medium",
  cursor: "pointer",
  display: "inline-flex",
  fontSize: 2,
  fontWeight: "bold",
  height: responsive({
    xs: "40px",
    sm: "50px"
  }),
  justifyContent: "center",
  lineHeight: 1,
  paddingX: responsive({
    xs: 3,
    sm: 4
  }),
  position: "relative",
  textAlign: "center",
  textDecoration: "none",
  textTransform: "uppercase",
  width: "auto",
  "&:hover, &:focus": {
    textDecoration: "none"
  },
  "&:focus": {
    outline: "none"
  }
};
var buttons = {
  primary: __assign(__assign({}, buttonBase), {
    borderColor: "primary",
    color: "primary",
    "&:hover, &:active": {
      color: function color(theme) {
        return getReadableColor(theme, "primary");
      },
      backgroundColor: "primary"
    },
    "&:disabled": {
      pointerEvents: "none",
      color: function color(theme) {
        return grayscale(getColor(theme, "primary"));
      },
      borderColor: function borderColor(theme) {
        return grayscale(getColor(theme, "primary"));
      }
    }
  }),
  secondary: __assign(__assign({}, buttonBase), {
    backgroundColor: "primary",
    borderColor: "primary",
    color: function color(theme) {
      return getReadableColor(theme, "primary");
    },
    "&:hover, &:active": {
      backgroundColor: "secondary",
      borderColor: "secondary",
      color: function color(theme) {
        return getReadableColor(theme, "secondary");
      }
    },
    "&:disabled": {
      pointerEvents: "none",
      backgroundColor: function backgroundColor(theme) {
        return grayscale(getColor(theme, "primary"));
      },
      color: function color(theme) {
        return grayscale(getReadableColor(theme, "primary"));
      },
      borderColor: function borderColor(theme) {
        return grayscale(getColor(theme, "primary"));
      }
    }
  }),
  showtime: __assign(__assign({}, buttonBase), {
    backgroundColor: "accent",
    borderColor: "accent",
    color: function color(theme) {
      return getReadableColor(theme, "accent");
    },
    cursor: "default",
    "&.expired": {
      textDecoration: "line-through"
    },
    "&.clickable": {
      cursor: "pointer",
      "&:hover": {
        borderColor: "secondary",
        color: function color(theme) {
          return getReadableColor(theme, "secondary");
        },
        backgroundColor: "secondary"
      }
    }
  }),
  tabItemPrimary: __assign(__assign({}, buttonBase), {
    borderRadius: 0,
    color: "primary",
    fontSize: responsive({
      xs: 3,
      sm: 3,
      md: 4
    }),
    fontWeight: "normal",
    lineHeight: "heading",
    minHeight: "3.5rem",
    paddingLeft: 2,
    paddingRight: 2,
    textTransform: "none",
    "&:hover, &.active": {
      backgroundColor: "secondary",
      color: "background"
    },
    "&.active": {
      pointerEvents: "none"
    }
  }),
  tabItemSecondary: __assign(__assign({}, buttonBase), {
    borderRadius: 0,
    color: "text",
    fontSize: responsive({
      xs: 2,
      sm: 2,
      md: 3,
      lg: 3
    }),
    fontWeight: "normal",
    lineHeight: "heading",
    minHeight: "3.5rem",
    paddingLeft: 2,
    paddingRight: 2,
    textTransform: "none",
    "&:hover, &.active": {
      color: "secondary"
    },
    "&.active": {
      pointerEvents: "none"
    }
  })
};
export default buttons;